// Generated by tools/pixellab/pack-mussolini.py from downloaded PixelLab metadata.
import type { EffectSheet } from "./moveEffects.ts";
export const MUSSOLINI_FX:Record<string,EffectSheet> = {
  "mussolini-flash": {
    "file": "../mussolini/mussolini-flash.png",
    "cols": 5,
    "rows": 1,
    "frames": 5,
    "fps": 30.303030303030305,
    "fill": 0.95,
    "aspect": 0.9696969696969697,
    "pivotX": 0.5,
    "pivotY": 0.5151515151515151
  },
  "mussolini-muzzle": {
    "file": "../mussolini/mussolini-muzzle.png",
    "cols": 5,
    "rows": 2,
    "frames": 6,
    "fps": 30.303030303030305,
    "fill": 0.95,
    "aspect": 1.6111111111111112,
    "pivotX": 0.10344827586206896,
    "pivotY": 0.5
  },
  "mussolini-explosion": {
    "file": "../mussolini/mussolini-explosion.png",
    "cols": 5,
    "rows": 3,
    "frames": 12,
    "fps": 17.857142857142858,
    "fill": 0.95,
    "aspect": 0.8382352941176471,
    "pivotX": 0.5263157894736842,
    "pivotY": 0.5441176470588235
  }
};
